<template src="./taxVue.template.html"></template>
<script>
  export default {
    name: "taxComponent",
    props: [],
    data() {
      return {
        propertyList: [],
        propertyId: "",
        statusList: [],
        statusId: 1,
        loading: true,
        taxItemList: [],
        toggleFilterPanel: false,
        viewSaveObject: {
          properties: [],
        },
        selectedFilterColumn: null,
        taxItemListCount: "",
        headerColumnList: [],
        headerColumnList: {
          PROPERTYNICKNAME:{
            Label: "PROPERTY NICK NAME",
            IsChecked: true,
            ColumnName: "PropertyNickName",
            isSortLoading: false, isAscOrDesc: null
          },
          TAXITEMNAME: { Label: "TAX ITEM NAME", IsChecked: true, ColumnName: "TaxItemName", isSortLoading: false, isAscOrDesc: null },
          DISPLAYNAME: {
            Label: "DISPLAY NAME",
            IsChecked: true,
            ColumnName: "TaxItemDisplayName"
          },
          CATEGORY: { Label: "CATEGORY", IsChecked: true, ColumnName: "Category", isSortLoading: false, isAscOrDesc: null },

          VALUE: { Label: "VALUE", IsChecked: true, ColumnName: "TaxItemValue", isSortLoading: false, isAscOrDesc: null },

          TAXITEMDESCRIPTION: { Label: "TAX ITEM DESCRIPTION", IsChecked: true, ColumnName: "TaxItemDescription", isSortLoading: false, isAscOrDesc: null },


          STATUS: { Label: "STATUS", IsChecked: true, ColumnName: "StatusId", isSortLoading: false, isAscOrDesc: null },


        },

        filterObj: {
          Properties: [],
          SortBy: null,
          SortOrder: null,
          Columns: []

        },
        filterColumnList: {
          TaxItemName: { Label: "Tax Item Name", ColumnName: "TaxItemName" },
          DisplayName: { Label: "TaxItemDisplayName", ColumnName: "TaxItemDisplayName" },
          Category: { Label: "Category", ColumnName: "Category" },
          TaxItemValue: { Label: "TaxItemValue", ColumnName: "TaxItemValue" },

        },
        filterSearchPropertyText: null,

      };
    },

    methods: {
      applyFilter() {
        let vm = this;
        vm.filterObj.SearchText = null;
        vm.toggleFilterPanel = false;
        //vm.$store.state.bus.$emit('clearSearchText');        
        vm.viewSaveObject.propertyId = vm.filterObj.PropertyId;
        // vm.viewSaveObject.UnitClassId = vm.filterObj.UnitClassId;
        // vm.viewSaveObject.resSourceId = vm.filterObj.resSourceId;

        // vm.viewSaveObject.tags.splice(0, vm.viewSaveObject.tags.length, ...vm.filterObj.TagsList);
        vm.viewSaveObject.properties.splice(0, vm.viewSaveObject.properties.length, ...vm.filterObj.Properties);
        // vm.viewSaveObject.UnitClasses.splice(0, vm.viewSaveObject.UnitClasses.length, ...vm.filterObj.UnitClasses);
        // vm.viewSaveObject.sources.splice(0, vm.viewSaveObject.sources.length, ...vm.filterObj.Sources);
        // vm.viewSaveObject.columns.splice(0, vm.viewSaveObject.columns.length, ...vm.filterObj.Columns);

        // vm.viewAttrsChanged = true;
        // vm.getReservationsList();
      },
      deleteSelectedPropertyFromFilter(index, propObj) {
        this.removePropertyFromFilter(propObj);
        this.viewSaveObject.properties.splice(index, 1);
      },
      addPropertyToFilter(propertyObj) {
        this.filterObj.Properties.push(propertyObj);
        this.filterSearchPropertyText = null;
      },
      removePropertyFromFilter(propertyObj) {
        if (propertyObj) {
          let index = this.filterObj.Properties.findIndex((currProperty) => {
            return currProperty.PropertyId === propertyObj.PropertyId;
          })
          if (index > -1) {
            this.filterObj.Properties.splice(index, 1);
          }
        }
      },
      showFilterByType(property) {
        if (this.selectedFilterColumn == property)
          this.selectedFilterColumn = null;
        else
          this.selectedFilterColumn = property;

      },
      closeFilter: function () {
        this.toggleFilterPanel = false
      },
      addColumnToFilters(colObj) {
        let index = this.filterObj.Columns.findIndex((currCol) => {
          return currCol.colunmName === colObj.ColumnName;
        })
        if (index === -1) {
          this.filterObj.Columns.push(JSON.parse(JSON.stringify({ colunmName: colObj.ColumnName, label: colObj.Label, text: null, arrText: [] })));
        }
      },
      addSearcTextToColumn(filterCol, event) {
        if (event.key == "Enter") {
          filterCol.arrText.push(filterCol.text);
          filterCol.text = null;
        }
      },
      removeSearchTextFromColumn(selectedText, filterCol) {
        if (filterCol.arrText.indexOf(selectedText) > -1) {
          filterCol.arrText.splice(filterCol.arrText.indexOf(selectedText), 1)
        }
      },


      ascSort(sortBy, sortOrder) {
        let vm = this;

        vm.filterObj.SortBy = sortBy;
        vm.filterObj.SortOrder = sortOrder;

        vm.getTaxItemList();
        for (var i in vm.headerColumnList) {

          var obj = vm.headerColumnList[i];
          console.log("obj", obj)
          if (sortBy.toString() === obj.ColumnName) {
            console.log("obj.ColumnName", obj.ColumnName);
            vm.headerColumnList[i].isSortLoading = true;
            vm.headerColumnList[i].isAscOrDesc = sortOrder.toString();
          }
        }

        //vm.getReservationsList(vm.propertyId, vm.UnitClassId, vm.ViewListId, SortBy, SortOrder, vm.sourceID);
      },
      switchView() {
        let scope = this;
        if (scope.listType === "list") scope.listType = "card";
        else scope.listType = "list";
      },

      getdefaultproperty() {
        let scope = this;

        scope.$store.dispatch("dataRequestHandler", {
          key: "GetUserEntitlementsAndDefaultProperty",
          params: {
            ModuleAction: "GetUserEntitlementsAndDefaultProperty"
          },
          callback: function (err, response) {
            if (response) {
              console.log(
                "GetUserEntitlementsAndDefaultProperty" +
                JSON.stringify(response.defaultPropertyId)
              );
              scope.propertyId = response.defaultPropertyId;
              scope.getTaxItemList();
            } else {
              console.log(err);
            }
          }
        });
      },

      getPropertyMetaData: function () {
        let vm = this;
        // scope.$store.dispatch("dataRequestHandler", {
        //   key: "GetPropertyMetaData",
        //   params: {
        //     ModuleAction: "GetPropertyMetaData",
        //     PropertyId: -99
        //   },
        //   callback: function (err, response) {
        //     if (response) {
        //       scope.propertyList = response.recordsets[1];
        //       scope.statusList = response.recordsets[3];
        //     } else {
        //       console.log(err);
        //     }
        //   }
        // });
        vm.$store.dispatch("dataRequestHandler", {
          key: "GetPropertiesBySearchText",
          params: {},
          callback: function (err, response) {
            if (err) {
              return;
            }
            if (response) {
              console.log("GetPropertiesBySearchText==>", response);
              vm.propertyList.splice(0, vm.propertyList.length, ...response.propertyList);
              vm.statusList.splice(0, vm.statusList.length, ...response.statusList);

            }
          }
        });

      },

      getTaxItemList: function () {
        let scope = this;
        scope.$store.dispatch("dataRequestHandler", {
          key: "GetTaxItemList",
          params: {
            ModuleAction: "GetTaxItemList",
            StatusId: scope.statusId,
            PropertyId: scope.propertyId,
            filterObj: scope.filterObj
          },
          callback: function (err, response) {
            if (response) {
              console.log(JSON.stringify(response));
              scope.taxItemList = response.recordsets[0];
              scope.taxItemListCount = response.recordsets[1][0].TaxItemsCount;
              if (scope.taxItemList.length > 0) {
                scope.$store.dispatch("toastr", {
                  type: "success",
                  header: "Success!",
                  message: "taxItemList  Rendered"
                });
              }



            } else {
              console.log(err);
            }
          }
        });
      },

      getTaxItemsListByProperty: function () {
        this.getTaxItemList();
      },

      taxDetail() {
        let scope = this;
        var TaxItemId = -1;
        scope.$router.push(
          "taxDetail/" + TaxItemId + "/" + scope.propertyId + "/" + scope.statusId
        );
      },

      viewTaxDetailById(TaxItem) {
        let scope = this;
        scope.$router.push(
          "taxDetail/" + TaxItem.TaxItemId + "/" + TaxItem.PropertyId + "/" + TaxItem.StatusId
        );
      },

      exportToExcel: function () { }
    },

    computed: {
      fncIsTaxItemNew() {
        let vm = this;
        if (vm.$store.state.userEntitlementList.hasOwnProperty("fncTaxItemNew")) {

          return vm.$store.state.userEntitlementList.hasOwnProperty("fncTaxItemNew") ? vm.$store.state.userEntitlementList.fncTaxItemNew : null;


        }
      },

      fncIsTaxItemsView() {
        let vm = this;
        if (vm.$store.state.userEntitlementList.hasOwnProperty("fncTaxItemsView")) {

          return vm.$store.state.userEntitlementList.hasOwnProperty("fncTaxItemsView") ? vm.$store.state.userEntitlementList.fncTaxItemsView : null;


        }
      }
    },

    mounted() {
      this.getdefaultproperty();
      this.getPropertyMetaData();
      // $(this.$el).find("ul.dropdown-menu").click(function (e) {
      //   e.stopPropagation();
      // });
    }
  };
</script>